import { Key, useState } from "react";
import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { ICustomerAccountSummary } from "../../../AccountTypes";
import { accountService } from "../../../AccountService";
import useNavModel from "@/model/navModel";
import { IMdOrgDetail, orgService } from "../../../../base/org/orgService";
import { ITreeData } from "../../../../base/dict/dictModel";
import { OptionDsType } from "@/types/FmsTypes";
import { useGlobalModel } from "@/model/globalModel";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { IMdDictFields } from "@/views/base/dict/dictService";

export enum ActionTypeEnum {
    ACCOUNT,
    ADJUST_LIST,
    RECHARGE_LIST,
    TRANSFER_LIst,
    BILL_LIST,
    WRITEOFF_LIST,
    LOG_LIST,
    SYSTEM_RECEIVABLE,
    NULL
}

type labelsType = {
    [proppName: string]: string;
}

export const useDetailModel = createModel(function () {
    const { user: { shopCode } } = useGlobalModel();
    const [customerCode, setCustomerCode] = useSessionStorageState<string>("accountShop.detail.customerCode", "");
    const [actionType, setActionType] = useSessionStorageState<ActionTypeEnum>("customerManage.detail.type", ActionTypeEnum.NULL) // 选中展示模块
    const [customer, setCustomer] = useState<ICustomerAccountSummary>({ key: "" });
    const { closeNav } = useNavModel(() => []);

    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
    const [beDs, setBeDs] = useState<OptionDsType[]>();
    const [appDs, setAppDs] = useState<OptionDsType[]>();
    const [payMethodLabels, setPayMethodLabels] = useState<labelsType>({});
    const [payMethodDs, setPayMethodDs] = useState<ITreeData<IMdDictFields>[]>();
    const [accountTypeDs, setAccountType] = useState<OptionDsType[]>([]);


    const loadSummaryData = (code?: Key) => {
        if (customerCode) {
            accountService
                .customerSummaryOne(customerCode, shopCode)
                .then(({ retData }) => {
                    setCustomer(retData ?? {});
                });
        }
    }

    return {
        appDs,
        orgDs,
        beDs,
        payMethodDs,
        payMethodLabels,
        actionType,
        customerCode,
        customer,
        accountTypeDs, setAccountType,
        setActionType,
        setCustomerCode,
        loadSummaryData,
        setOrgDs,
        setBeDs,
        setPayMethodDs,
        setPayMethodLabels,
        setAppDs,
        closeNav,
    }
});
